import "../../../assets/css/font.css.ts.vanilla.mjs";
import "./ReoInput.css.ts.vanilla.mjs";
import "./ReoTextArea.css.ts.vanilla.mjs";
var r = "p273__ReoTextArea-043a_fc7059a17__pcwfdm5", p = "p273__ReoTextArea-043a_fc7059a17__pcwfdm8", t = "p273__ReoInput-55db_f4c4595__1mw21jv3", c = "p273__ReoTextArea-043a_fc7059a17__pcwfdm4", o = "p273__ReoInput-55db_f4c4595__1mw21jv7", f = "p273__ReoInput-55db_f4c4595__1mw21jv4", v = "p273__ReoInput-55db_f4c4595__1mw21jv5", m = "p273__ReoInput-55db_f4c4595__1mw21jv6", d = "p273__ReoTextArea-043a_fc7059a17__pcwfdm3", n = "p273__ReoTextArea-043a_fc7059a17__pcwfdm7", x = "p273__ReoTextArea-043a_fc7059a17__pcwfdm0", R = "p273__ReoTextArea-043a_fc7059a17__pcwfdm2", u = "p273__ReoTextArea-043a_fc7059a17__pcwfdm6", w = "p273__ReoTextArea-043a_fc7059a17__pcwfdm1";
export {
  r as bottomInfo,
  p as content,
  t as focused,
  c as info,
  o as inputDisabled,
  f as inputError,
  v as inputSuccess,
  m as inputWarning,
  d as isOverMax,
  n as labelForInput,
  x as textArea,
  R as textAreaDataCount,
  u as textAreaRequired,
  w as textAreaWrap
};
//# sourceMappingURL=ReoTextArea.mjs.map
